<template>
	<div class="about3">
		<div class="about3-c">
			<div class="about3-info">
				<div class="item">
					<div class="h">
						业务领域
					</div>
					<div class="s">
						光伏、风电、储能、电力等领域运维与能效管理
					</div>  
					<div class="imgs">
						<div class="imgs-item">
							<img class="imgs-item-bgimg" src="../../assets/service/service11.png" alt="">
							<img class="imgs-item-logo" src="../../assets/qywh/guangfu.png" alt="">
							<div class="t">光伏</div>
							<div class="s">领域运维与能效管理</div>
						</div>
						<div class="imgs-item">
							<img class="imgs-item-bgimg" src="../../assets/service/service22.png" alt="">
							<img class="imgs-item-logo" src="../../assets/qywh/fengdian.png" alt="">
							<div class="t">风电</div>
							<div class="s">领域运维与能效管理</div>
						</div>
						<div class="imgs-item">
							<img class="imgs-item-bgimg" src="../../assets/service/service33.png" alt="">
							<img class="imgs-item-logo" src="../../assets/qywh/a-ziyuan25.png" alt="">
							<div class="t">储能</div>
							<div class="s">领域运维与能效管理</div>
						</div>
						<div class="imgs-item">
							<img class="imgs-item-bgimg" src="../../assets/service/service44.png" alt="">
							<img class="imgs-item-logo" src="../../assets/qywh/dianli.png" alt="">
							<div class="t">电力</div>
							<div class="s">领域运维与能效管理</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="about3-c" style="background-color: #F3F9F9;">
			<div class="about3-info">
				<div class="item">
					<div class="h">
						业务区域
					</div>
					<div class="s">
						立足于华东，遍布全国范围；
						设有运维中心+华东、华南、中原、华北、西北、西南六大区域中心。
					</div>  
					<div class="imgs1">
						<img class="imgs-item-logo" src="../../assets/ys/service/140.png" alt="">
					</div>
				</div>
			</div>
		</div>
		
		<!-- <div class="service-yw">
			<div class="service-yw-c">
				<div class="service-yw-c-h">运维工具</div>
				<div class="service-yw-c-b">
					<div class="item" style="background-color: white;">
						<img src="../../../public/imgs/service3/1@2x.png" alt="">
						<div class="t">智能运维平台</div>
						<div class="s">数据采集与传输系统</div>
						<div class="s">远程监控与控制系统</div>
						<div class="s">数据智能分析</div>
						<div class="s"> </div>
					</div>
					<div class="item" style="background-color: white;">
						<img src="../../../public/imgs/service3/2@2x.png" alt="">
						<div class="t">移动端APP管理工具</div>
						<div class="s">及时预警及时故障处理</div>
						<div class="s">终端数据统计与分析</div>
						<div class="s">实时监控</div>
						<div class="s"> </div>
					</div>
					<div class="item"  style="background-color: white;">
						<img src="../../../public/imgs/service3/2@2x1.png" alt="">
						<div class="t">智能化运维设备与工具</div>
						<div class="s">无人机巡检</div>
						<div class="s">自动清洗除尘</div>
						<div class="s">红外抄表</div>
						<div class="s">机器人巡检配电房</div>
					</div>
					<div class="item" style="background-color: white;">
						<img src="../../../public/imgs/service3/4@2x.png" alt="">
						<div class="t">运维值守制度和操作规范</div>
						<div class="s">运维管理制度</div>
						<div class="s">操作守则规程等智能运维</div>
						<div class="s">24小时双岗值守</div>
						<div class="s" style="color: white;">  _</div>
					</div>
				</div>
			</div>
		</div> --> 
		
		<div class="service3-c3">
			<div class="service3-c3-title">
				运维工具
			</div>
			<div class="service3-c3-box">
				<div class="item">
					<div class="item-l">
						<div class="item-l-t1">智能运维平台</div>
						<div class="item-l-t2"></div>
						<div class="item-l-t3">·数据采集与传输系统</div>
						<div class="item-l-t3">·远程监控与控制系统</div>
						<div class="item-l-t3">·数据智能分析</div>
					</div>
					<img src="../../assets/service/service3-1.png" alt="" />
				</div>
				<div class="item">
					<img src="../../assets/service/service3-2.png" alt="" />
					<div class="item-l">
						<div class="item-l-t1">移动端APP管理工具</div>
						<div class="item-l-t2"></div>
						<div class="item-l-t3">·及时预警及时故障处理</div>
						<div class="item-l-t3">·终端数据统计与分析</div>
						<div class="item-l-t3">·实时监控</div>
					</div>
				</div>
				<div class="item">
					<div class="item-l">
						<div class="item-l-t1">智能化运维设备与工具</div>
						<div class="item-l-t2"></div>
						<div class="item-l-t3">·无人机巡检</div>
						<div class="item-l-t3">·自动清洗除尘</div>
						<div class="item-l-t3">·红外抄表</div>
						<div class="item-l-t3">·机器人巡检配电房</div>
					</div>
					<img src="../../assets/service/service3-3.png" alt="" />
				</div>
				<div class="item">
					<img src="../../assets/service/service3-4.png" alt="" />
					<div class="item-l">
						<div class="item-l-t1">运维值守制度和操作规范</div>
						<div class="item-l-t2"></div>
						<div class="item-l-t3">·运维管理制度</div>
						<div class="item-l-t3">·操作守则规程等智能运维</div>
						<div class="item-l-t3">·24小时双岗值守</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="service-type" style="background-color: #22A3D3;">
			<div class="service-type-c">
				<div class="item">
					<img src="../../assets/imgs/更安全.png" alt="">
					更安全
				</div>
				<div class="item">
					<img src="../../assets/imgs/更可靠.png" alt="">
					更可靠
				</div>
				<div class="item">
					<img src="../../assets/imgs/更高效.png" alt="">
					更高效
				</div>
				<div class="item">
					<img src="../../assets/imgs/更经济.png" alt="">
					更智能
				</div>
			</div>
		</div>
		
	    
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			}
		},
		data() {
			return {
				mlist:[
					{
						title:"光伏",
						sec:"领域运维与能效管理",
						logo:"../../../public/images/guangfu@2x.png",
						bgimg:"../../../public/images/蒙版@2x (2).png"
					},
					{
						title:"风电",
						sec:"领域运维与能效管理",
						logo:"../../../public/images/fengdian@2x.png",
						bgimg:"../../../public/images/蒙版@2x (3).png"
					},
					{
						title:"储能",
						sec:"领域运维与能效管理",
						logo:"../../../public/images/a-ziyuan25@2x.png",
						bgimg:"../../../public/images/编组 20@2x.png"
					},
					{
						title:"电力",
						sec:"领域运维与能效管理",
						logo:"../../../public/images/dianli@2x.png",
						bgimg:"../../../public/images/蒙版@2x (4).png"
					}
				],
				ywList:[
					{
						title:"智能运维平台",
						sec:"数据采集与传输系统",
					},
					{
						title:"移动端APP管理工具",
						sec:"及时预警及时故障处理",
					},
					{
						title:"智能化运维设备与工具",
						sec:"无人机巡检",
					},
					{
						title:"运维值守制度和操作规范",
						sec:"运维管理制度",
					}
				]

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}

	.about3 {
		.service-yw {
			background-color: white;
			display: flex;
			justify-content: center;
			.service-yw-c {
			
				.service-yw-c-h {
					text-align: center;
		
					color: #332C2B;
				}
				.service-yw-c-b {
					justify-content: space-between;
					align-items: center;
					.item {
						
						flex-direction: column;
						justify-content: flex-start;
						align-items: left;
					 
						.t {
							
							color: #332C2B;
						}
						.s {
							
							color: #666666;
						}
					}
				}
			}
			
		}

		.about3-c {
			background-color: white;
			justify-content: center;
			.about3-info {
				
				.item {
					text-align: center;
					.h {
						color: #332C2B;
					}
					.s {
						
						color: #999999;
					}
					.imgs {
						justify-content: space-between;
						align-items: center;
						flex-wrap: wrap;
						.imgs-item:hover {
							transition: width 0.3s, height 0.3s;
							transform: scale(0.95);
							
						}
						.imgs-item{
							transition: transform 0.3s;
							position: relative;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							text-align: center;
							color: white;
							div {
								position: relative;
								z-index: 3;
							}
							.imgs-item-bgimg {
								position: absolute;
								
								z-index: 0;
							}
							.imgs-item-logo {
								
								position: relative;
								z-index: 3;
							}
							.s {
								color: white;
							}
							
						}
					}
					.imgs1 {
						
						justify-content: center;
						align-items: center;
						
					}
				}		
			}
		}
		
		.service-type {
			background-image: url(../../assets/ys/service/77.png);
	        background-size: 100% 100%;
			background-repeat: no-repeat;
			display: flex;
			justify-content: center;
			align-items: center;
			.service-type-bgimg {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				z-index: 1;
			}
			.service-type-c {
				display: flex;
				justify-content: space-between;
				align-items: center;
				.item {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					color: #FFFFFF;
					img {
						
					}
				}
			}
	    }
	    
		.service3-c3 {
			width: 100%;
			background-color: white;
			.service3-c3-title {
				text-align: center;
			}
			.service3-c3-box {
				
				.item {
					background-color: #F3F9F9;
					width: 100%;
					
					display: flex;
					justify-content: space-between;
					align-items: center;
					img {
						width: 50%;
					}
					.item-l {
						width: 50%;
						.item-l-t1 {
							font-weight: 500;
							color: #332C2B;
						}
						.item-l-t2 {
							
							background-color: #22A3D3;
						}
						.item-l-t3 {
							color:#666666;
							
						}
					}
				}
			}
		}
	}
	
	@media screen and (min-width: 1200px) {
		.about3 {
			width: 100%;
			.service-yw {
				width: 100%;
				display: flex;
				padding: 80px 0 80px;
				.service-yw-c {
					width: 1200px;
					.service-yw-c-h {
						font-size: 32px;
					}
					.service-yw-c-b {
						margin-top: 80px;
						display: flex;
						.item {
							flex: 1;
							display: flex;
							img {
								width: 100px;
								height: 80px;
							}  
							.t {
								margin-top: 32px;
								font-size: 24px;
							}
							.s {
								margin-top: 20px;
								font-size: 16px;
							}
						}
					}
				}
				
			}
		
			.about3-c {
				width: 100%;
				display: flex;
				padding: 60px 0 60px;
				.about3-info {
					width: 1200px;
					.item {
						margin-bottom: 32px;
						.h {
							font-size: 32px;
						}
						.s {
							margin-top: 16px;
							margin-bottom: 32px;
							font-size: 16px;
						}
						.imgs {
							width: 100%;
							display: flex;
							.imgs-item{
								width: calc(50% - 20px);
								height: 320px;
								display: flex;
								margin-bottom: 40px;
								.imgs-item-bgimg {
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
								}
								.imgs-item-logo {
									width: 45px;
									height: 45px;
								}
								.t {
									font-size: 28px;
								}
								.s {
									margin-top: 12;
									font-size: 18px;
								}
							}
						}
						.imgs1 {
							width: 100%;
							display: flex;
							
							img {
								width: 1020px;
								height: 750px;
							}
						}
					}		
				}
			}
			
			.service-type {
				width: 100%;
				height: 320px;
				.service-type-c {
					width: 1200px;
					.item {
						width: 120px;
						font-size: 24px;
						img {
							width: 45px;
							height: 52px;
							margin-bottom: 20px;
						}
					}
				}
			}
		    
			.service3-c3 {
				padding: 60px 0;
				.service3-c3-title {
					font-size: 20px;
				}
				.service3-c3-box {
					width: 1200px;
					margin-left: calc(50% - 600px);
					margin-top: 40px;
					.item {
						margin-bottom: 24px;
						height: 400px;
						padding: 30px;
					
						img {
							height: 340px;
						}
						.item-l {
							padding-left: 30px;
							.item-l-t1 {
								font-size: 28px;
							}
							.item-l-t2 {
								width: 120px;
								height: 2px;
								margin-top: 16px;
								margin-bottom: 16px;
							}
							.item-l-t3 {
								font-size: 17px;
								margin-bottom: 10px;
							}
						}
					}
				}
			}
		
		}
	
	}
	@media screen and (max-width: 1200px) {
		.about3 {
			width: 100%;
			.service-yw {
				width: 100%;
				display: flex;
				padding: 60px 0;
				.service-yw-c {
					width: 100%;
					
					.service-yw-c-h {
						font-size: 24px;
					}
					.service-yw-c-b {
						margin-top: 60px;
						display: flex;
						padding: 0 20px;
						.item {
							width: calc(50% - 12px);
							display: flex;
							img {
								width: 80px;
								height: 60px;
							}  
							.t {
								margin-top: 18px;
								font-size: 16px;
							}
							.s {
								margin-top:10px;
								font-size: 14px;
							}
						}
					}
				}
				
			}
		
			.about3-c {
				width: 100%;
				display: flex;
				padding: 60px 0 60px;
				.about3-info {
					width: 100%;
					padding: 0 20px;
					.item {
						margin-bottom: 20px;
						.h {
							font-size: 18px;
						}
						.s {
							margin-top: 12px;
							font-size: 15px;
							margin-bottom: 20px;
						}
						.imgs {
							width: 100%;
							display: flex;
							.imgs-item{
								width: calc(50% - 12px);
								height: 280px;
								display: flex;
								margin-bottom: 20px;
								.imgs-item-bgimg {
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
								}
								.imgs-item-logo {
									width: 30px;
									height: 30px;
								}
								.t {
									font-size: 18px;
								}
								.s {
									margin-top: 10px;
									font-size: 16px;
								}
							}
						}
						.imgs1 {
							width: 100%;
							display: flex;
							
							img {
								width: 80%;
								// height: 750px;
							}
						}
					}		
				}
			}
		
		    
			.service3-c3 {
				padding: 40px 0;
				.service3-c3-title {
					font-size: 18px;
				}
				.service3-c3-box {
					width: 100%;
					margin-top: 30px;
					.item {
						margin-bottom: 18px;
						height: 300px;
						padding: 20px;
					
						img {
							height: 260px;
						}
						.item-l {
							padding-left: 20px;
							.item-l-t1 {
								font-size: 20px;
							}
							.item-l-t2 {
								width: 80px;
								height: 2px;
								margin-top: 12px;
								margin-bottom: 12px;
							}
							.item-l-t3 {
								font-size: 15px;
								margin-bottom: 8px;
							}
						}
					}
				}
			}
			
		}
		
		.service-type {
			width: 100%;
			height: 240px;
			padding: 0 20px;
			.service-type-c {
				width: 100%;
				.item {
					width: 80px;
					font-size: 20px;
					img {
						width: 30px;
						height: 36px;
						margin-bottom: 10px;
					}
				}
			}
		}
	
	}
	@media screen and (max-width: 880px) {
		.about3 {
			width: 100%;
			.service-yw {
				width: 100%;
				display: flex;
				padding: 30px 0;
				.service-yw-c {
					width: 100%;
					
					.service-yw-c-h {
						font-size: 18px;
					}
					.service-yw-c-b {
						width: 100%;
						margin-top: 30px;
						display: flex;
						flex-wrap: wrap;
						padding: 0 12px;
						.item {
							width: 50%;  
							display: flex;
							img {
								width: 50px;
								height: 30px;
							}  
							.t {
								margin-top: 12px;
								font-size: 15px;
							}
							.s {
								margin-top:8px;
								font-size: 13px;
							}
						}
					}
				}
				
			}
		
			.about3-c {
				width: 100%;
				display: flex;
				padding: 30px 0;
				.about3-info {
					width: 100%;
					padding: 0 12px;
					.item {
						margin-bottom: 12px;
						.h {
							font-size: 16px;
						}
						.s {
							margin-top: 12px;
							font-size: 14px;
							margin-bottom: 12px;
						}
						.imgs {
							width: 100%;
							display: flex;
							.imgs-item{
								width: calc(50% - 12px);
								height: 200px;
								display: flex;
								
								margin-bottom: 12px;
								.imgs-item-bgimg {
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
								}
								.imgs-item-logo {
									width: 20px;
									height: 20px;
								}
								.t {
									font-size: 16px;
								}
								.s {
									margin-top: 10px;
									font-size: 15px;
								}
							}
						}
						.imgs1 {
							width: 100%;
							display: flex;
							
							img {
								width: 80%;
								// height: 750px;
							}
						}
					}		
				}
			}
		    
			.service3-c3 {
				padding: 20px 0;
				.service3-c3-title {
					font-size: 16px;
				}
				.service3-c3-box {
					width: 100%;
					margin-top: 16px;
					.item {
						margin-bottom: 14px;
						height: 200px;
						padding: 10px;
					
						img {
							height: 180px;
						}
						.item-l {
							padding-left: 10px;
							.item-l-t1 {
								font-size: 16px;
							}
							.item-l-t2 {
								width: 60px;
								height: 2px;
								margin-top: 8px;
								margin-bottom: 8px;
							}
							.item-l-t3 {
								font-size: 14px;
								margin-bottom: 8px;
							}
						}
					}
				}
			}
		}
		
		.service-type {
			width: 100%;
			height: 180px;
			padding: 0 12px;
			.service-type-c {
				width: 100%;
				height: 180px;
				.item {
					width: 25%;
					font-size: 16px;
					img {
						width: 20px;
						height: 24px;
						margin-bottom: 8px;
					}
				}
			}
		}
	
	}
</style>
